import { render, staticRenderFns } from "./Group.vue?vue&type=template&id=09dd3596&scoped=true"
import script from "./Group.vue?vue&type=script&lang=js"
export * from "./Group.vue?vue&type=script&lang=js"
import style0 from "./Group.vue?vue&type=style&index=0&id=09dd3596&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dd3596",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/render/project/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09dd3596')) {
      api.createRecord('09dd3596', component.options)
    } else {
      api.reload('09dd3596', component.options)
    }
    module.hot.accept("./Group.vue?vue&type=template&id=09dd3596&scoped=true", function () {
      api.rerender('09dd3596', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Group.vue"
export default component.exports